export default "__VITE_ASSET__2DWaE1uX__"